import { useHistory } from "react-router-dom";
import { Card } from "../../../components/card.component";
import { AppRouteUi } from "../../../config/appRoute";
import { AddAppointment } from "../../../features/appointment/addAppointment.component";
import { useState } from "react";

export const PageAppointmentAdd = () => {
  const routeHistory = useHistory<{ from?: string }>();
  const [title, setTitle] = useState("");

  return (
    <Card
      header={
        <div className="row align-items-center justify-content-between">
          <div className="col content-box-title">
            <div className="d-flex align-items-center">
              <div
                onClick={() => {
                  routeHistory.length > 1
                    ? routeHistory.goBack()
                    : routeHistory.push(AppRouteUi.Root);
                }}
                className="pe-2 border-2  click text-green-200"
              >
                <i className="fas fa-arrow-left text-green-200" />
              </div>
              <div className="d-flex flex-column border-start">
                <p className="text-capitalize mb-0 ps-2  text-green-200">
                  Add New Appointment
                </p>
                {!!title && (
                  <p className="ps-2 pb-1 small-text">(For {title})</p>
                )}
              </div>
            </div>
            <div className="collapse-icon"></div>
          </div>
        </div>
      }
    >
      <AddAppointment setTitle={setTitle} showAvailableDays />
    </Card>
  );
};
